import { render, staticRenderFns } from "./coursedetails.vue?vue&type=template&id=457ffc79&scoped=true"
import script from "./coursedetails.vue?vue&type=script&lang=js"
export * from "./coursedetails.vue?vue&type=script&lang=js"
import style0 from "./coursedetails.vue?vue&type=style&index=0&id=457ffc79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457ffc79",
  null
  
)

export default component.exports